var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title"},[_c('h2',[_vm._v("Add Product")]),_c('product-form',{attrs:{"model":_vm.model},on:{"save-product":_vm.createProduct}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }